import { localizeWithPath, localize2WithPath } from 'vscode/vscode/vs/nls';
import { Extensions } from 'vscode/vscode/vs/workbench/common/views';
import { OutlinePane } from './outlinePane.js';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions as Extensions$1 } from 'vscode/vscode/vs/platform/configuration/common/configurationRegistry';
import { VIEW_CONTAINER } from 'vscode/vscode/vs/workbench/contrib/files/browser/explorerViewlet';
import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { Codicon } from 'vscode/vscode/vs/base/common/codicons';
import { registerIcon } from 'vscode/vscode/vs/platform/theme/common/iconRegistry';
import { IOutlinePane } from 'vscode/vscode/vs/workbench/contrib/outline/browser/outline';
import './outlineActions.js';

const _moduleId = "vs/workbench/contrib/outline/browser/outline.contribution";
const outlineViewIcon = registerIcon('outline-view-icon', Codicon.symbolClass, ( localizeWithPath(_moduleId, 0, 'View icon of the outline view.')));
( (Registry.as(Extensions.ViewsRegistry))).registerViews([{
        id: IOutlinePane.Id,
        name: ( localize2WithPath(_moduleId, 1, "Outline")),
        containerIcon: outlineViewIcon,
        ctorDescriptor: ( (new SyncDescriptor(OutlinePane))),
        canToggleVisibility: true,
        canMoveView: true,
        hideByDefault: false,
        collapsed: true,
        order: 2,
        weight: 30,
        focusCommand: { id: 'outline.focus' }
    }], VIEW_CONTAINER);
( (Registry.as(Extensions$1.Configuration))).registerConfiguration({
    'id': 'outline',
    'order': 117,
    'title': ( localizeWithPath(_moduleId, 2, "Outline")),
    'type': 'object',
    'properties': {
        ["outline.icons" ]: {
            'description': ( localizeWithPath(_moduleId, 3, "Render Outline elements with icons.")),
            'type': 'boolean',
            'default': true
        },
        ["outline.collapseItems" ]: {
            'description': ( localizeWithPath(_moduleId, 4, "Controls whether Outline items are collapsed or expanded.")),
            'type': 'string',
            scope: 5 ,
            'enum': [
                'alwaysCollapse',
                'alwaysExpand'
            ],
            'enumDescriptions': [
                ( localizeWithPath(_moduleId, 5, "Collapse all items.")),
                ( localizeWithPath(_moduleId, 6, "Expand all items."))
            ],
            'default': 'alwaysExpand'
        },
        ["outline.problems.enabled" ]: {
            'markdownDescription': ( localizeWithPath(
                _moduleId,
                7,
                "Show errors and warnings on Outline elements. Overwritten by `#problems.visibility#` when it is off."
            )),
            'type': 'boolean',
            'default': true
        },
        ["outline.problems.colors" ]: {
            'markdownDescription': ( localizeWithPath(
                _moduleId,
                8,
                "Use colors for errors and warnings on Outline elements. Overwritten by `#problems.visibility#` when it is off."
            )),
            'type': 'boolean',
            'default': true
        },
        ["outline.problems.badges" ]: {
            'markdownDescription': ( localizeWithPath(
                _moduleId,
                9,
                "Use badges for errors and warnings on Outline elements. Overwritten by `#problems.visibility#` when it is off."
            )),
            'type': 'boolean',
            'default': true
        },
        'outline.showFiles': {
            type: 'boolean',
            scope: 5 ,
            default: true,
            markdownDescription: ( localizeWithPath(_moduleId, 10, "When enabled, Outline shows `file`-symbols."))
        },
        'outline.showModules': {
            type: 'boolean',
            scope: 5 ,
            default: true,
            markdownDescription: ( localizeWithPath(_moduleId, 11, "When enabled, Outline shows `module`-symbols."))
        },
        'outline.showNamespaces': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 12, "When enabled, Outline shows `namespace`-symbols."))
        },
        'outline.showPackages': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 13, "When enabled, Outline shows `package`-symbols."))
        },
        'outline.showClasses': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 14, "When enabled, Outline shows `class`-symbols."))
        },
        'outline.showMethods': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 15, "When enabled, Outline shows `method`-symbols."))
        },
        'outline.showProperties': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 16, "When enabled, Outline shows `property`-symbols."))
        },
        'outline.showFields': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 17, "When enabled, Outline shows `field`-symbols."))
        },
        'outline.showConstructors': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 18, "When enabled, Outline shows `constructor`-symbols."))
        },
        'outline.showEnums': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 19, "When enabled, Outline shows `enum`-symbols."))
        },
        'outline.showInterfaces': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 20, "When enabled, Outline shows `interface`-symbols."))
        },
        'outline.showFunctions': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 21, "When enabled, Outline shows `function`-symbols."))
        },
        'outline.showVariables': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 22, "When enabled, Outline shows `variable`-symbols."))
        },
        'outline.showConstants': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 23, "When enabled, Outline shows `constant`-symbols."))
        },
        'outline.showStrings': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 24, "When enabled, Outline shows `string`-symbols."))
        },
        'outline.showNumbers': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 25, "When enabled, Outline shows `number`-symbols."))
        },
        'outline.showBooleans': {
            type: 'boolean',
            scope: 5 ,
            default: true,
            markdownDescription: ( localizeWithPath(_moduleId, 26, "When enabled, Outline shows `boolean`-symbols."))
        },
        'outline.showArrays': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 27, "When enabled, Outline shows `array`-symbols."))
        },
        'outline.showObjects': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 28, "When enabled, Outline shows `object`-symbols."))
        },
        'outline.showKeys': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 29, "When enabled, Outline shows `key`-symbols."))
        },
        'outline.showNull': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 30, "When enabled, Outline shows `null`-symbols."))
        },
        'outline.showEnumMembers': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 31, "When enabled, Outline shows `enumMember`-symbols."))
        },
        'outline.showStructs': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 32, "When enabled, Outline shows `struct`-symbols."))
        },
        'outline.showEvents': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 33, "When enabled, Outline shows `event`-symbols."))
        },
        'outline.showOperators': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 34, "When enabled, Outline shows `operator`-symbols."))
        },
        'outline.showTypeParameters': {
            type: 'boolean',
            default: true,
            scope: 5 ,
            markdownDescription: ( localizeWithPath(_moduleId, 35, "When enabled, Outline shows `typeParameter`-symbols."))
        }
    }
});
